import { axios } from "@app/app/services/axios";
import { queryClient } from "@app/app/services/queryClient";

import { QueryKeys } from "./constants/QueryKeys";
import { ICountry, IExchangeRates, IPromoDiscount, ITranslation } from "./types";

export const getExchangeRates = async (propertyId: string): Promise<IExchangeRates> => {
    const response = await axios.get(`properties/${propertyId}/exchanges`);

    return response.data;
};

export const getPromoDiscount = async (code: string, propertyId: string, loyaltyAccessToken?: string): Promise<IPromoDiscount> => {
    const response = await axios.get(`properties/${propertyId}/promos?code=${code}`, {
        headers: {
            "Public-Token": loyaltyAccessToken ?? "",
        },
    });

    return response.data;
};

export const getTranslations = async (propertyId: string): Promise<ITranslation> => {
    const response = await axios.get(`properties/${propertyId}/translations`);

    return response.data;
};

export const getCommonTranslations = async (): Promise<ITranslation> => {
    const response = await axios.get("/translations");

    return response.data;
};

export const getCountries = async (): Promise<ICountry[]> => {
    const response = await axios.get("countries");

    return response.data;
};

export const prefetchExchangeRates = (propertyId: string) =>
    queryClient.prefetchQuery([QueryKeys.ExchangeRateItems, propertyId], () => getExchangeRates(propertyId), {
        staleTime: 1000 * 60 * 1, // 1 minute
    });
